module.exports = __webpack_public_path__ + "static/media/burgers.f15bb1e8.jpg";